/**
 * `otgIds` on which we are releasing the AI interactive education features with
 */
export const AI_INTERACTIVE_EDUCATION_RELEASE_OTG_IDS = [9491375, 9605393, 8633750, 8488213, 8034589, 8034588, 7599256, 4763235, 2965397, 5736482];